export type ReportColumns = Record<string, { name: string; description: string; value: unknown }>;

export const columnsFromRow = (row: any): ReportColumns | undefined => {
  const entries = Object.entries(row?.values || {});
  if (!entries.length) return undefined;
  return entries.reduce((acc: ReportColumns, [key, value]: [string, unknown]) => {
    acc[key] = { name: '', description: '', value };
    return acc;
  }, {});
};

export const splitNestedColumns = (
  children: any[] = [],
  fallbackColumns?: ReportColumns
): { childColumns: ReportColumns | undefined; childRows: any[] } => {
  const inferred = children.length > 0 ? columnsFromRow(children[0]) : undefined;
  if (!inferred) return { childColumns: fallbackColumns, childRows: children };
  return { childColumns: inferred, childRows: children.slice(1) };
};
